import React, { useEffect } from 'react';
import {
  Switch,
  Route,
  useLocation
} from 'react-router-dom';

import './css/style.scss';

import { focusHandling } from 'cruip-js-toolkit';
import './charts/ChartjsConfig';

// Import pages
import Dashboard from './pages/Dashboard';
import Landing from './pages/Landing';
import Integrations from './pages/Integrations';
import Compose from './pages/Compose';
import WebPush from './pages/WebPush';
import Settings from './pages/Settings';
import Signin from './pages/Signin';
import SubProfile from './pages/SubProfile';
import TagManager from 'react-gtm-module'

import { getApp } from "firebase/app"
import { getMessaging, onMessage } from "firebase/messaging";
import { API } from 'aws-amplify';
import jBox from 'jbox'
import 'jbox/dist/jBox.all.css';

import HubSpotCallback from './pages/callbacks/HubSpotCallback'
import IntercomCallback from './pages/callbacks/IntercomCallback'
import WixCallback from './pages/callbacks/WixCallback'
import WixCallbackMarketplace from './pages/callbacks/WixCallbackMarketplace'
import BigCommerceMarketplace from './pages/callbacks/BigCommerceCallbackMarketplace'
import SquareUpCallback from './pages/callbacks/SquareUpCallback'
import ShopifyCallback from './pages/callbacks/ShopifyCallback'
import ShopifyCallbackMarketplace from './pages/callbacks/ShopifyCallbackMarketplace'
import SquareSpaceCallback from './pages/callbacks/SquareSpaceCallback'
import WebsiteCallback from './pages/callbacks/WebsiteCallback'
import CallToActions from "./pages/CallToActions"
import AIdeate from "./pages/AIdeate"

function App() {


  const messaging = getMessaging(getApp('push'));

  const tagManagerArgs = {
    gtmId: 'GTM-TNQHTXT'
  }
  const location = useLocation();

  useEffect(()=>{
    TagManager.initialize(tagManagerArgs)
  }, [])

  function clicked(notification){
    // Update with clicked logic
    console.log(notification)
    const apiName = 'DashboardAPI'; // replace this with your api name.
    const path = '/web-push/notification-event'; //replace this with the path you have configured on your API
    const myInit = {
      body: {
        id: notification.data.id,
        task: 'opened'
      },
    };
    API
      .post(apiName, path, myInit)
  }

  function webPushDelivered(notification){
    const apiName = 'DashboardAPI'; // replace this with your api name.
    const path = '/web-push/notification-event'; //replace this with the path you have configured on your API
    const myInit = {
      body: {
        id: notification.id,
        task: 'delivered'
      },
    };
    API
      .post(apiName, path, myInit)
  }

  useEffect(() => {
    onMessage(messaging, (payload) => {
      try{
        webPushDelivered(payload['data'])
        var ticker = payload['data']['ticker']
        var content = payload['data']['content']
        new jBox('Notice', {title: ticker, content: content, color: 'blue', position: {x: 'center', y: 20},
          animation: {open: 'tada', close: 'flip'}, autoClose: false, delayOnHover: true, onCreated: function () {
            document.getElementById(this.id).addEventListener('click', () => clicked(payload));
          }});
      } catch(e){}
    });
  }, [])

  /*useEffect(() => {
    const scriptTag = document.createElement('script');

    scriptTag.src = "//fast.appcues.com/94695.js";
    scriptTag.async = true;

    document.body.appendChild(scriptTag);
    return () => {
      document.body.removeChild(scriptTag);
    }
  }, []);*/

  useEffect(() => {
    document.querySelector('html').style.scrollBehavior = 'auto'
    window.scroll({ top: 0 })
    document.querySelector('html').style.scrollBehavior = ''
    focusHandling('outline');

    /*if(window.Appcues!=null && window.Appcues!=undefined) {
      window.Appcues.page()
    }*/

  }, [location.pathname]); // triggered on route change

  return (
    <>
      <Switch>
        <Route exact path="/">
          <Dashboard />
        </Route>
        <Route exact path="/integrations">
          <Integrations />
        </Route>
        <Route exact path="/call-to-actions">
          <CallToActions />
        </Route>
        <Route exact path="/aideate">
          <AIdeate />
        </Route>
        <Route exact path="/compose">
          <Compose />
        </Route>
        <Route exact path="/webpush">
          <WebPush />
        </Route>
        <Route exact path="/settings">
          <Settings />
        </Route>
        <Route exact path="/callback/website">
          <WebsiteCallback />
        </Route>
        <Route exact path="/callback/hubspot">
          <HubSpotCallback />
        </Route>
        <Route exact path="/callback/intercom">
          <IntercomCallback />
        </Route>
        <Route exact path="/callback/wix">
          <WixCallback />
        </Route>
        <Route exact path="/callback/squareup">
          <SquareUpCallback />
        </Route>
        <Route exact path="/callback/shopify">
          <ShopifyCallback />
        </Route>
        <Route exact path="/callback/squarespace">
          <SquareSpaceCallback />
        </Route>
        <Route exact path="/callback/marketplace/wix">
          <WixCallbackMarketplace />
        </Route>
        <Route exact path="/callback/marketplace/bigcommerce">
          <BigCommerceMarketplace />
        </Route>
        <Route exact path="/callback/marketplace/shopify">
          <ShopifyCallbackMarketplace />
        </Route>
        <Route exact path="/signin">
          <Signin />
        </Route>
        <Route exact path="/subprofile/:id">
          <SubProfile />
        </Route>
        <Route exact path="/landing">
          <Landing />
        </Route>
      </Switch>
    </>
  );
}

export default App;
